import { jsx } from "react/jsx-runtime";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { validateTidalLicense } from "../../base/index.js";
function LocalOffer(props) {
  return /* @__PURE__ */ jsx(
    LocalOfferIcon,
    {
      "data-testid": "LocalOffer",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "LocalOffer",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
LocalOffer.tidalIconMeta = {
  categories: "miscellaneous",
  name: "LocalOffer"
};
validateTidalLicense();
export {
  LocalOffer
};
//# sourceMappingURL=LocalOffer.js.map
